import React, { Component } from 'react'
import moment from 'moment'
import { Collapse, Button, Icon } from 'antd'
import ContactsCollapse from './Collapse'

const { Panel } = Collapse

class Leads extends Component {
  renderElement = lead => {
    const { handleRowLeadsClick } = this.props
    const { id, name, type, created_date } = lead
    const createdDate = moment.utc(created_date).format('M/D/YYYY')
    return (
      <Panel key={id} header={name}>
        <div className="row">
          <div className="col-md-5">
            <div className="jobDetailsHeader">Name:</div>
            <span>{name}</span>
          </div>
          <div className="col-md-3">
            <div className="jobDetailsHeader">Type:</div>
            <span>{type}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Created:</div>
            <span>{createdDate}</span>
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Edit:</div>
            <Button onClick={() => handleRowLeadsClick(lead)}>
              <Icon type="edit" />
            </Button>
          </div>
        </div>
      </Panel>
    )
  }
  render() {
    const contactLeads = this.props.contactLeads || []
    return (
      <div>
        <div className="row">
          <div className="col-md-6">
            <h4>Leads</h4>
          </div>
        </div>
        <ContactsCollapse emptyText="There are no leads for this contact">
          {contactLeads.map(this.renderElement)}
        </ContactsCollapse>
      </div>
    )
  }
}

export default Leads



// WEBPACK FOOTER //
// ./src/components/contacts/Leads.js